module.exports = __webpack_public_path__ + "static/media/noOffer.816ab0bc.png";